<template>
  <div class="visitor-pbadge-container">
    <VisitorPrintBadge v-if="hasBadge" :badge="badge" />
  </div>
</template>

<script>
import VisitorPrintBadge from "@/v3components/shared/VisitorPrint/VisitorPrintBadge.vue"
import { computed, onUnmounted, ref, watch } from "vue"
export default {
  name: "VisitorBrotherPrinterContainer",
  components: { VisitorPrintBadge },
  props: {
    badge: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["done"],
  setup(props, { emit }) {
    const timeoutId = ref(null)
    const hasBadge = computed(() => Object.keys(props.badge).length > 0)

    watch(
      () => hasBadge.value,
      (newVal) => {
        if (newVal) {
          timeoutId.value = setTimeout(() => {
            emit("done")
          }, 500)
        }
      }
    )

    onUnmounted(() => {
      if (timeoutId.value) {
        clearTimeout(timeoutId.value)
      }
    })

    return {
      hasBadge
    }
  }
}
</script>

<style scoped></style>
